export default {
    detail_of_samsa_order: [],
    error_samsa_order: "",
    success_api_samsa_order: ''
}